var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIcoCookies = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18,
    height: 17.996,
    viewBox: "0 0 18 17.996",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "ico_Cookies",
    transform: "translate(-313.503 -75.357)",
    fill: "#999"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_48596",
    "data-name": "Path 48596",
    d: "M322.891,93.173h-.771l-.182-.017c-.244-.02-.49-.025-.731-.062a8.747,8.747,0,0,1-3.558-1.341,9.032,9.032,0,0,1-3.144-3.447,9,9,0,0,1,2.177-10.979,8.621,8.621,0,0,1,2.85-1.629,7.8,7.8,0,0,1,2.566-.481.857.857,0,0,1,.649.284.7.7,0,0,1,.2.665,2.974,2.974,0,0,1-.2.577,2.7,2.7,0,0,0,3.555,3.6c.163-.069.319-.156.484-.219a.828.828,0,0,1,1.076.513c.035.107.069.215.1.325a1.768,1.768,0,0,0,.714,1.076,1.657,1.657,0,0,0,1.467.287c.082-.025.167-.039.25-.059a.722.722,0,0,1,.531.075.932.932,0,0,1,.5.716,8.743,8.743,0,0,1,.064.988,8.489,8.489,0,0,1-.49,3.09,8.907,8.907,0,0,1-2.939,4.108,8.808,8.808,0,0,1-4.733,1.9C323.183,93.154,323.037,93.162,322.891,93.173Zm-4.016-8.085a2.715,2.715,0,1,0-2.7-2.7A2.725,2.725,0,0,0,318.875,85.088Zm9.944.879a.868.868,0,0,0-.881.871c.007.076,0,.154,0,.229a.7.7,0,0,0,.05.212.91.91,0,0,0,1.092.483.93.93,0,0,0,.638-1.006A.941.941,0,0,0,328.819,85.967Zm-6.336,3.583a.707.707,0,0,0-.305-.654.858.858,0,0,0-.943-.139.888.888,0,0,0-.544.808.914.914,0,0,0,.887.944A.877.877,0,0,0,322.483,89.551Zm1.826-2.669a.868.868,0,0,0,.9-.969.9.9,0,0,0-.955-.839.944.944,0,0,0-.865.946A.9.9,0,0,0,324.309,86.882Z",
    transform: "translate(0 .18)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48597",
    "data-name": "Path 48597",
    d: "M874.875,137.367c-.012.047-.024.093-.038.14a.886.886,0,0,1-.989.622.912.912,0,0,1-.728-.928.9.9,0,0,1,.963-.795.883.883,0,0,1,.776.7.259.259,0,0,0,.016.041Z",
    transform: "translate(-543.372 -59.236)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_48598",
    "data-name": "Path 48598",
    d: "M719.635,74.7a.9.9,0,0,1-.9.878.919.919,0,0,1-.837-.9.874.874,0,0,1,.869-.865A.893.893,0,0,1,719.635,74.7Z",
    transform: "translate(-392.651 1.545)"
  }))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIcoCookies);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/ico_cookies.fa86d1d3b7561932fd152d867eeb2047.svg";